module.exports = __webpack_public_path__ + "static/img/image11.4d58a45f.png";